// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#skills .skill-icons{
    color: #aaaaaa;
}

ul.skill-icons {
    cursor: default;
    list-style: none;
    padding-left: 0;
}

ul.skill-icons li {
    display: inline-block;
    padding: 0 1em 0 0;
    font-size: 5em;
}

ul.skill-icons li > * {
    text-decoration: none;
    border: 0;
    color: black;
}


.small-font {
    font-size: -2em;
}
`, "",{"version":3,"sources":["webpack://./src/components/Skills/Skills.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,SAAS;IACT,YAAY;AAChB;;;AAGA;IACI,eAAe;AACnB","sourcesContent":["#skills .skill-icons{\n    color: #aaaaaa;\n}\n\nul.skill-icons {\n    cursor: default;\n    list-style: none;\n    padding-left: 0;\n}\n\nul.skill-icons li {\n    display: inline-block;\n    padding: 0 1em 0 0;\n    font-size: 5em;\n}\n\nul.skill-icons li > * {\n    text-decoration: none;\n    border: 0;\n    color: black;\n}\n\n\n.small-font {\n    font-size: -2em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
